import script from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginComponent.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__